import React from "react";
import MasterDetailLayout from "../../../components/layout/MasterDetailLayout";
import WorkCompactList from "../components/WorkCompactList";

const WorkSplitView = () => <MasterDetailLayout list={<WorkCompactList />} />;

export default WorkSplitView;
